import PostItemDesktop from './post-item.desktop';

export default PostItemDesktop;
